/**
 * 邮箱登录相关校验
 */

/**
 * 邮箱格式校验
 * 使用行业通用正则，并限制总长度不超过 254，且只允许 ASCII 字符。
 */
const EMAIL_REGEX = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;

const MAX_EMAIL_LENGTH = 254;
const ASCII_REGEX = /^[\x00-\x7F]+$/;

export function isValidEmail(value: string): boolean {
  const trimmed = value.trim();
  if (!trimmed || trimmed.length > MAX_EMAIL_LENGTH) {
    return false;
  }
  if (!ASCII_REGEX.test(trimmed)) {
    return false;
  }
  return EMAIL_REGEX.test(trimmed);
}
